import { take, fork, select, put, call } from 'redux-saga/effects';
import actionTypes from '../actionTypes';
import { callApi } from "./callApi";
import config from "../../config/config";
import {getCurrentClubAdminAccount, getCurrentClubToken, getCurrentClubId} from "../selectors";
import {showNotification} from "../actionCreators/notification";
import {makeTransferList, makeGameTransferList} from "./helpers/transfers";
import {successBalanceTransfer, successClubTransfers, successGameTransfers, failureGameTransfers} from "../actionCreators/transfers";
import { createBrowserHistory } from 'history';

const browserHistory = createBrowserHistory();

function* balanceTransfer( { amount, memberIds, transferType } ) {
    try {
        const isSendOut = transferType === 'sendOut';
        const {id: accountId, token} =  yield select(getCurrentClubAdminAccount);

        const transactions = memberIds.map( memberId => {
            return {
                source: isSendOut ? accountId : memberId,
                destination: isSendOut ? memberId : accountId,
                amount
            }
        });
        console.log('balanceTransfer: transactions: ', transactions);

        yield call(callApi, `${config.API_URL}/club/transactions`, 'POST', { transactions, token });
        //
        yield put(successBalanceTransfer());
        // yield  browserHistory.goBack();
        yield put(showNotification({message: 'Transfers succeeded !'}));
    } catch (e) {}
}

function* getClubTransfers( { dateFrom, dateTo }) {
    try {
        const token =  yield select(getCurrentClubToken);
        const clubId =  yield select(getCurrentClubId);
        const status = ['completed'];
        const response = yield call(callApi, `${config.API_URL}/club/transaction`, 'GET', { token, status, dateFrom, dateTo });
        //
        yield put(successClubTransfers(makeTransferList({transfers: response.data.result.movements, clubId})));
    } catch (e) {}
}

function* getGameTransfers( { dateFrom, dateTo }) {
    try {
        const token =  yield select(getCurrentClubToken);
        const type = 'gameMovement';
        const response = yield call(callApi, `${config.API_URL}/transaction`, 'GET', { token, type, dateFrom, dateTo });
        
        yield put(successGameTransfers(makeGameTransferList(response.data.result.movements)));
    } catch (e) {
        yield put(failureGameTransfers(e));
    }
}

export function* watchBalanceTransfer() {
    while (true) {
        const action = yield take(actionTypes.BALANCE_TRANSFER_REQUEST);
        yield fork(balanceTransfer, action);
    }
}

export function* watchClubTransfers() {
    while (true) {
        const action = yield take(actionTypes.CLUB_TRANSFERS_REQUEST);
        yield fork(getClubTransfers, action);
    }
}

export function* watchGameTransfers() {
    while (true) {
        const action = yield take(actionTypes.GAME_TRANSFERS_REQUEST);
        yield fork(getGameTransfers, action);
    }
}
